<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12 style="text-align: right">
          <h3 style="float: left">Версии POH пользователей</h3>
          <v-btn color="blue" dark small fab @click="refresh()">
            <v-icon>refresh</v-icon>
          </v-btn>
        </v-flex>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-text-field
                flat
                solo
                prepend-icon="search"
                placeholder="Поиск"
                v-model="search"
                hide-details
                class="hidden-sm-and-down"
              ></v-text-field>
              <v-btn
                v-if="!showDetailedSearch"
                @click="showDetailedSearch = true"
                icon
              >
                <v-icon>filter_list</v-icon>
              </v-btn>
              <v-btn
                v-if="showDetailedSearch"
                @click="clearDetailedSearch"
                icon
              >
                <v-icon>clear</v-icon>
              </v-btn>
            </v-toolbar>

            <v-slide-y-transition>
              <v-layout
                v-if="showDetailedSearch"
                style="padding-left: 25px; padding-right: 25px"
                card
                color="white"
              >
                <v-flex
                  v-for="dsOpt in detailedSearchOptions"
                  :key="dsOpt.searchKey"
                >
                  <v-text-field
                    flat
                    prepend-icon="search"
                    :placeholder="dsOpt.placeholder"
                    v-model="dsOpt.text"
                    hide-details
                    class="hidden-sm-and-down"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-slide-y-transition>

            <v-divider></v-divider>

            <v-card-text class="pa-0">
              <v-data-table
                :headers="complex.headers"
                :search="search"
                :items="filteredData"
                :rows-per-page-items="[10,25,50,100]"
                class="elevation-1"
                no-results-text="Нет результатов"
                rows-per-page-text="На странице"
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.staffId }}</td>
                  <td>{{ props.item.staffPgName }}</td>
                  <td>{{ props.item.staffFullName }}</td>
                  <td>{{ props.item.appVersion }}</td>
                  <td>{{ props.item.lastModified }}</td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
    data () {
        return {
            search: '',
            showDetailedSearch: false,
            detailedSearchOptions: [
              {
                placeholder: "Staff ID",
                searchKey: "staffId",
                text: ""
              },
              {
                placeholder: "PG код",
                searchKey: "staffPgName",
                text: ""
              },
              {
                placeholder: "ФИО",
                searchKey: "staffFullName",
                text: ""
              },
            ],
            complex: {
                headers: [
                    {
                        text: "Staff ID",
                        value: 'staffId'
                    },
                    {
                        text: "PG код",
                        value: 'staffPgName'
                    },
                    {
                        text: 'ФИО',
                        value: 'staffFullName'
                    },
                    {
                        text: 'Версия POH',
                        value: 'appVersion'
                    },
                    {
                        text: 'Дата последнего изменения',
                        value: 'lastModified'
                    }
                ],
            }
        };
    },

    mounted: function () {
        /**
         * Загрузить данные при первой отрисовке страницы
         */
        if (this.data.length === 0) {
          this.refresh();
        }
    },

    computed: {
        /**
         * Данные о версиях приложений пользователей
         * @returns {default.computed.data|(function())|Array|getters.data}
         */
        data () {
            return this.$store.getters['accountAppVersion/data']
        },

        /**
         * Фильтрованные данные о версиях приложений пользователей
         */
        filteredData() {
          let result = this.data;

          this.detailedSearchOptions.forEach(dsOpt => {
            if (dsOpt.text !== "") {
              result = result.filter(tsd => String(tsd[dsOpt.searchKey]).toLowerCase().indexOf(dsOpt.text.toLowerCase()) !== -1);
            }
          });

          return result;
        },
    },

    methods: {
        /**
         * Очистить и закрыть детальный фильтр
         */
        clearDetailedSearch() {
          this.detailedSearchOptions.forEach(s => (s.text = ""));
          this.showDetailedSearch = false;
        },

        /**
         * Обновить данные
         */
        refresh () {
            this.$store._actions['accountAppVersion/getData'][0]();
        },
    }
};
</script>


// WEBPACK FOOTER //
// src/pages/ui/AccountAppVersion.vue